var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTextfieldClose = function SvgIconTextfieldClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.054 1.346a.5.5 0 0 0-.707.708l3.889 3.889-3.89 3.889a.5.5 0 0 0 .708.707l3.889-3.89 3.889 3.89a.5.5 0 0 0 .707-.707L6.65 5.942l3.889-3.888a.5.5 0 1 0-.707-.708l-3.89 3.89-3.888-3.89Z",
    fill: "#919599"
  })));
};
export default SvgIconTextfieldClose;